import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '@evento-ng/libs';
@Component({
  selector: 'app-toasts-container',
  templateUrl: './toasts-container.component.html',
  styleUrls: ['./toasts-container.component.scss'],
})
export class ToastsContainerComponent {
  constructor(public toast: ToastService) {}

  isTemplate(toast: any): any {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
